module.exports = __webpack_public_path__ + "img/antalya.08f060e1.png";